import { useState, useContext } from 'react';
import * as firebase from 'config/firebase.config';
import AuthenticationContext from 'contexts/Authentication.context';
import EmployeesService from 'services/employees.service';
import AuthenticationService from 'services/authentication.service';

export default function useAuthentication() {
  const { auth, user, reload } = useContext(AuthenticationContext);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);

  const isAuthenticated = () => {
    return user !== undefined ? user !== null : false;
  }

  const signInWithEmailAndPassword = async (email, password) => {
    await firebase.auth.signInWithEmailAndPassword(email, password);
  }

  const signInWithCustomToken = async (token) => {
    await firebase.auth.signInWithCustomToken(token);
  }

  const login = async (session, token) => {
    const response = await AuthenticationService.login(session, token);
    if(response.success) {
      await firebase.auth.signInWithCustomToken(response.payload);
      return {success: true};
    }
    return {success: false};
  }

  const signOut = async () => {
    await firebase.auth.signOut();
  }

  const update = {
    status: async (newStatus) => {
      try {
        setIsUpdatingStatus(true);
        return await EmployeesService.updateStatus(newStatus);
      } catch (error) {
        console.log('Error updating status', error);
      } finally {
        setIsUpdatingStatus(false);
      }
    }
  }

  return {
    user,
    login,
    auth,
    signOut,
    isAuthenticated,
    signInWithCustomToken,
    signInWithEmailAndPassword,
    reload,
    update,
    isUpdatingStatus
  };
}